import React from 'react';
import { Sparkles } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-white py-10 md:py-14 px-4" data-id="element-141">
      <div className="max-w-2xl mx-auto text-center" data-id="element-142">
        <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-3 font-['Oswald'] uppercase" data-id="element-143">
          💡 Aquí es donde todo cambia.
        </h2>

        <p className="text-base text-gray-700 mb-2" data-id="element-144">
          <strong data-id="element-145">"El Asombroso Viaje por el Cuerpo Humano"</strong> no es un
          libro común.
        </p>
        <p className="text-base text-gray-600 mb-6" data-id="element-146">
          Es una experiencia visual, interactiva y divertida que hace que los
          niños:
        </p>

        <div className="space-y-3 max-w-sm mx-auto mb-6" data-id="element-147">
          {['Se interesen por aprender', 'Hagan preguntas', 'Descubran por sí mismos'].map((item, idx) => <div key={idx} className="flex items-center gap-3 bg-blue-50 p-3 rounded-lg text-left" data-id="element-148">
              <Sparkles className="w-5 h-5 text-blue-500 flex-shrink-0" data-id="element-149" />
              <span className="text-sm font-bold text-gray-800" data-id="element-150">{item}</span>
            </div>)}
        </div>

        <p className="text-lg font-bold text-gray-900" data-id="element-151">
          👉 Sin presión. Sin obligarlos.
        </p>
      </div>
    </section>;
}